import SortVerticalIcon from "@svg/explore/sort";
import classNames from "classnames";
import { useExploreSort } from "./hooks/useExploreSort";
import { useRouter } from "next/router";
import { FC, useEffect, useState } from "react";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import { EXPLORE_SLUG } from "types/api/explore";
import { exploreTitle } from "constants/new-explore/valid-filters";

interface Props {
  count?: number;
}

const SortBox: FC<Props> = ({ count }) => {
  const [csCount, setCsCount] = useState(0);

  useEffect(() => {
    setCsCount(count || 0);
  }, [count]);

  const router = useRouter();
  const { query } = router;
  const { sortItems, activeSort, handleSelectSort } = useExploreSort();

  return (
    <div
      className={classNames(
        "flex w-full items-center border-b border-b-fds-default mb-6 box-content",
        sortItems?.length ? "justify-between " : "justify-end"
      )}
    >
      {sortItems.length ? (
        <div className="flex justify-between items-center">
          <div className="py-2.5 ml-2 flex items-center text-fds-secondary">
            <SortVerticalIcon className="ml-1" />
            <p className="text-sm h-5 font-medium text-fds-secondary">
              مرتب‌سازی بر اساس:
            </p>
          </div>
          <div className="flex gap-x-4 items-stretch ">
            {sortItems.map(({ query, persian_name }) => (
              <div
                key={query}
                className={classNames(
                  "p-3 items-stretch box-content relative cursor-pointer",
                  {
                    "after:content-[''] after:h-0.5 after:bg-fds-brand after:w-full after:right-0 after:rounded-t-2 after:absolute after:-bottom-px ":
                      activeSort === query,
                  }
                )}
                onClick={() => handleSelectSort(query)}
              >
                <p
                  className={classNames(
                    "text-sm font-medium",
                    activeSort === query
                      ? "text-fds-brand"
                      : "text-fds-secondary"
                  )}
                >
                  {persian_name}
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {csCount ? (
        <p className="font-normal text-sm text-[#747981] self-end py-2.5">
          {separateMoneyNumbers(toFarsiNumber(csCount))}{" "}
          {exploreTitle[String(query.slug) as EXPLORE_SLUG] || "عنوان آموزشی"}
        </p>
      ) : null}
    </div>
  );
};

export default SortBox;
